import {
  DELETE_POI_FAILURE,
  DELETE_POI_REQUEST,
  DELETE_POI_SUCCESS,
  FETCH_POI_COMPLETE_FAILURE,
  FETCH_POI_COMPLETE_REQUEST,
  FETCH_POI_COMPLETE_SUCCESS,
  FETCH_POI_FAILURE,
  FETCH_POI_REQUEST,
  FETCH_POI_SUCCESS,
  FETCH_POIS_FAILURE,
  FETCH_POIS_REQUEST,
  FETCH_POIS_SUCCESS,
  SAVE_POI_FAILURE,
  SAVE_POI_REQUEST,
  SAVE_POI_SUCCESS,
  FETCH_POIS_DROPDOWN_REQUEST,
  FETCH_POIS_DROPDOWN_SUCCESS,
  FETCH_POIS_DROPDOWN_FAILURE,
} from '../../reducers/types';
import {
  deletePoisService,
  getPoiByIdService,
  getPoiCompleteByIdService,
  getPoisService,
  savePoiService,
  getPoisDropdownService,
} from '../../services/appCmsServices/PoiService';
import { poisPaginationParams } from '../../pages/appCms/poi/Constants';

export const getPoisAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POIS_REQUEST,
      });
      // const response = await dispatch(getPoisService({ ...poisPaginationParams }))
      const response = await dispatch(getPoisService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POIS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POIS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POIS_FAILURE,
      });
    }
  };
};

export const getPoisDropdownAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POIS_DROPDOWN_REQUEST,
      });
      const response = await dispatch(getPoisDropdownService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POIS_DROPDOWN_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POIS_DROPDOWN_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POIS_DROPDOWN_FAILURE,
      });
    }
  };
};

export const savePoiAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_POI_REQUEST,
      });
      const response = await dispatch(savePoiService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_POI_SUCCESS,
          payload: response.data,
        });
        dispatch(getPoisAction({ ...poisPaginationParams }));
      } else {
        dispatch({
          type: SAVE_POI_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_POI_FAILURE,
      });
    }
  };
};

export const deletePoisAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_POI_REQUEST,
      });
      const response = await dispatch(deletePoisService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_POI_SUCCESS,
        });
        dispatch(getPoisAction({ ...poisPaginationParams }));
      } else {
        dispatch({
          type: DELETE_POI_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_POI_FAILURE,
      });
    }
  };
};

export const getPoiByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_REQUEST,
      });
      const response = await dispatch(getPoiByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_FAILURE,
      });
    }
  };
};

export const getPoiCompleteByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_COMPLETE_REQUEST,
      });
      const response = await dispatch(getPoiCompleteByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_COMPLETE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_COMPLETE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_COMPLETE_FAILURE,
      });
    }
  };
};

// export const getPoiImageByIdAction = id => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_POI_IMAGE_REQUEST,
//       });
//       const response = await dispatch(getPoiImageByIdService(id));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_POI_IMAGE_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_POI_IMAGE_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_POI_IMAGE_FAILURE,
//       });
//     }
//   };
// };

// export const getSimplePoiListAction = (idList, all) => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_SIMPLE_POI_LIST_PDF_REQUEST,
//       });
//       const response = await dispatch(getSimplePoiListService(idList, all));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_SIMPLE_POI_LIST_PDF_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_SIMPLE_POI_LIST_PDF_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_SIMPLE_POI_LIST_PDF_FAILURE,
//       });
//     }
//   };
// };

// export const getCustomPoiListAction = idList => {
//   return async dispatch => {
//     try {
//       dispatch({
//         type: FETCH_CUSTOM_POI_LIST_PDF_REQUEST,
//       });
//       const response = await dispatch(getCustomPoiListService(idList));
//       if (response.status === 200) {
//         dispatch({
//           type: FETCH_CUSTOM_POI_LIST_PDF_SUCCESS,
//           payload: response.data,
//         });
//       } else {
//         dispatch({
//           type: FETCH_CUSTOM_POI_LIST_PDF_FAILURE,
//         });
//         throw Error;
//       }
//     } catch (error) {
//       // eslint-disable-next-line no-console
//       console.error(error);
//       dispatch({
//         type: FETCH_CUSTOM_POI_LIST_PDF_FAILURE,
//       });
//     }
//   };
// };
